import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "decont-page" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "hero" }
const _hoisted_4 = { class: "grid-card" }
const _hoisted_5 = { class: "grid-head" }
const _hoisted_6 = { class: "nr-badge" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "hero" }
const _hoisted_9 = { class: "hero-txt" }
const _hoisted_10 = { class: "hero-title" }
const _hoisted_11 = { class: "hero-sub" }
const _hoisted_12 = { class: "hero-actions" }
const _hoisted_13 = { class: "grid-card mb-4" }
const _hoisted_14 = { class: "grid-head" }
const _hoisted_15 = {
  key: 0,
  class: "pa-6 text-center text-medium-emphasis"
}
const _hoisted_16 = {
  key: 1,
  class: "pa-6 text-center text-medium-emphasis"
}
const _hoisted_17 = {
  key: 2,
  class: "tbl"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "txt-right" }
const _hoisted_20 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "txt-right total-val" }
const _hoisted_23 = ["colspan"]
const _hoisted_24 = {
  key: 0,
  class: "d-flex justify-end"
}
const _hoisted_25 = { class: "dlg-head" }
const _hoisted_26 = { class: "dlg-ic" }
const _hoisted_27 = { class: "dlg-head" }
const _hoisted_28 = { class: "dlg-ic" }
const _hoisted_29 = { class: "d-flex ga-3 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_file_input = _resolveComponent("v-file-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.activ)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "hero-txt" }, [
              _createElementVNode("div", { class: "hero-eyebrow" }, "PORTAL HR"),
              _createElementVNode("h1", { class: "hero-title" }, "Deconturi"),
              _createElementVNode("p", { class: "hero-sub" }, "Cheltuielile tale de decontat: creează, adaugă documente și trimite spre aprobare.")
            ], -1)),
            _createVNode(_component_v_btn, {
              class: "btn-nou",
              "prepend-icon": "mdi-plus",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogNou = true))
            }, {
              default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                _createTextVNode("Decont nou", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "#ff5722",
                class: "mr-2"
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createTextVNode("mdi-cash-multiple", -1)
                ]))]),
                _: 1
              }),
              _cache[24] || (_cache[24] = _createElementVNode("span", null, "Deconturile mele", -1))
            ]),
            _createVNode(_component_DxDataGrid, {
              "data-source": _ctx.deconturi,
              "key-expr": "ID",
              "show-borders": false,
              "show-column-lines": false,
              "show-row-lines": true,
              "hover-state-enabled": true,
              "row-alternation-enabled": false,
              "no-data-text": _ctx.loading ? 'Se încarcă…' : 'Nu ai niciun decont încă.'
            }, {
              nrCell: _withCtx(({ data }) => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(data.data.Numar || '—'), 1)
              ]),
              stareCell: _withCtx(({ data }) => [
                _createElementVNode("span", {
                  class: "stare-pill",
                  style: _normalizeStyle(_ctx.starePillStyle(data.data.Stare))
                }, [
                  _createElementVNode("span", {
                    class: "dot",
                    style: _normalizeStyle({ background: _ctx.stareColor(data.data.Stare) })
                  }, null, 4),
                  _createTextVNode(" " + _toDisplayString(_ctx.stareLabel(data.data.Stare)), 1)
                ], 4)
              ]),
              actCell: _withCtx(({ data }) => [
                _createVNode(_component_v_btn, {
                  size: "small",
                  variant: "outlined",
                  color: "#ff5722",
                  onClick: ($event: any) => (_ctx.deschide(data.data))
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode("Vizualizează", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_DxColumn, {
                  "data-field": "Numar",
                  caption: "Număr",
                  width: 130,
                  "cell-template": "nrCell"
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Data",
                  caption: "Data",
                  "data-type": "date",
                  format: "dd.MM.yyyy",
                  width: 130
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Explicatie",
                  caption: "Explicație",
                  "min-width": 220
                }),
                _createVNode(_component_DxColumn, {
                  "data-field": "Stare",
                  caption: "Stare",
                  width: 170,
                  "cell-template": "stareCell"
                }),
                _createVNode(_component_DxColumn, {
                  caption: "",
                  width: 150,
                  "allow-filtering": false,
                  "allow-sorting": false,
                  "cell-template": "actCell"
                }),
                _createVNode(_component_DxPaging, { "page-size": 12 }),
                _createVNode(_component_DxSorting, { mode: "single" }),
                _createVNode(_component_DxFilterRow, { visible: true })
              ]),
              _: 1
            }, 8, ["data-source", "no-data-text"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[26] || (_cache[26] = _createElementVNode("div", { class: "hero-eyebrow" }, "PORTAL HR", -1)),
              _createElementVNode("h1", _hoisted_10, "Decont " + _toDisplayString(_ctx.activ.Numar), 1),
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.activ.Explicatie), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", {
                class: "stare-pill light",
                style: _normalizeStyle(_ctx.starePillStyle(_ctx.activ.Stare))
              }, [
                _createElementVNode("span", {
                  class: "dot",
                  style: _normalizeStyle({ background: _ctx.stareColor(_ctx.activ.Stare) })
                }, null, 4),
                _createTextVNode(" " + _toDisplayString(_ctx.stareLabel(_ctx.activ.Stare)), 1)
              ], 4),
              _createVNode(_component_v_btn, {
                class: "btn-back",
                variant: "text",
                "prepend-icon": "mdi-arrow-left",
                onClick: _ctx.inapoi
              }, {
                default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                  _createTextVNode("Înapoi", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "#ff5722",
                class: "mr-2"
              }, {
                default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                  _createTextVNode("mdi-format-list-bulleted", -1)
                ]))]),
                _: 1
              }),
              _cache[30] || (_cache[30] = _createElementVNode("span", null, "Documente", -1)),
              _createVNode(_component_v_spacer),
              (_ctx.esteDraft)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    size: "small",
                    class: "btn-nou",
                    "prepend-icon": "mdi-plus",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogLinie = true))
                  }, {
                    default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                      _createTextVNode("Adaugă linie", -1)
                    ]))]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.loadingDetalii)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, "Se încarcă…"))
              : (!_ctx.linii.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, "Niciun document adăugat."))
                : (_openBlock(), _createElementBlock("table", _hoisted_17, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[31] || (_cache[31] = _createElementVNode("th", null, "Tip", -1)),
                        _cache[32] || (_cache[32] = _createElementVNode("th", null, "Nr. document", -1)),
                        _cache[33] || (_cache[33] = _createElementVNode("th", null, "Data", -1)),
                        _cache[34] || (_cache[34] = _createElementVNode("th", null, "Partener", -1)),
                        _cache[35] || (_cache[35] = _createElementVNode("th", null, "Total", -1)),
                        _cache[36] || (_cache[36] = _createElementVNode("th", null, "Explicație", -1)),
                        _cache[37] || (_cache[37] = _createElementVNode("th", null, "Atașamente", -1)),
                        (_ctx.esteDraft)
                          ? (_openBlock(), _createElementBlock("th", _hoisted_18))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.linii, (l) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: l.ID
                        }, [
                          _createElementVNode("td", null, _toDisplayString(l.TipNume), 1),
                          _createElementVNode("td", null, _toDisplayString(l.Numar || '—'), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.fmt(l.DataDoc)), 1),
                          _createElementVNode("td", null, _toDisplayString(l.PartenerNume || '—'), 1),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.formatSuma(l.Total)) + " " + _toDisplayString(l.SimbolValuta), 1),
                          _createElementVNode("td", null, _toDisplayString(l.Explicatie || '—'), 1),
                          _createElementVNode("td", null, [
                            (!l.Fisiere || !l.Fisiere.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "—"))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(l.Fisiere, (f) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: f.FisierID,
                                    class: "fisier-chip"
                                  }, [
                                    _createVNode(_component_v_icon, { size: "14" }, {
                                      default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                        _createTextVNode("mdi-paperclip", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createTextVNode(_toDisplayString(f.Nume), 1)
                                  ]))
                                }), 128))
                          ]),
                          (_ctx.esteDraft)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                                _createVNode(_component_v_btn, {
                                  icon: "mdi-delete-outline",
                                  size: "small",
                                  variant: "text",
                                  color: "red",
                                  onClick: ($event: any) => (_ctx.stergeLinie(l.ID))
                                }, null, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _cache[39] || (_cache[39] = _createElementVNode("td", {
                          colspan: "4",
                          class: "txt-right total-lbl"
                        }, "Total", -1)),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.formatSuma(_ctx.totalLinii)), 1),
                        _createElementVNode("td", {
                          colspan: _ctx.esteDraft ? 3 : 2
                        }, null, 8, _hoisted_23)
                      ])
                    ])
                  ]))
          ]),
          (_ctx.esteDraft)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createVNode(_component_v_btn, {
                  class: "btn-nou px-6",
                  disabled: !_ctx.linii.length,
                  loading: _ctx.trimiterePendinta,
                  onClick: _ctx.trimite
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                        _createTextVNode("mdi-send", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[41] || (_cache[41] = _createTextVNode("Trimite decont ", -1))
                  ]),
                  _: 1
                }, 8, ["disabled", "loading", "onClick"])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogNou,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dialogNou) = $event)),
      "max-width": "520",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          rounded: "xl",
          class: "dlg-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_v_icon, {
                  color: "#fff",
                  size: "20"
                }, {
                  default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                    _createTextVNode("mdi-cash-plus", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[43] || (_cache[43] = _createElementVNode("div", null, [
                _createElementVNode("div", { class: "dlg-title" }, "Decont nou"),
                _createElementVNode("div", { class: "dlg-desc" }, "Creează un decont, apoi adaugă documentele.")
              ], -1)),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                color: "#fff",
                size: "small",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogNou = false))
              })
            ]),
            _createVNode(_component_v_card_text, { class: "pa-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _ctx.formNouValid,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formNouValid) = $event)),
                  ref: "formNou"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.formNou.ProiectID,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formNou.ProiectID) = $event)),
                      items: _ctx.proiecte,
                      "item-title": "Nume",
                      "item-value": "Id",
                      label: "Proiect",
                      variant: "outlined",
                      density: "comfortable",
                      class: "mb-4",
                      loading: _ctx.loadingLookups,
                      "hide-details": "auto",
                      clearable: ""
                    }, null, 8, ["modelValue", "items", "loading"]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.formNou.Explicatie,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formNou.Explicatie) = $event)),
                      label: "Explicație",
                      variant: "outlined",
                      density: "comfortable",
                      rows: "3",
                      rules: [_ctx.required],
                      "hide-details": "auto"
                    }, null, 8, ["modelValue", "rules"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.errNou)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "error",
                      variant: "tonal",
                      density: "compact",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.errNou), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dlg-foot" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dialogNou = false))
                }, {
                  default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  class: "btn-nou px-6",
                  loading: _ctx.loadingNou,
                  disabled: !_ctx.formNouValid,
                  onClick: _ctx.creeazaDecont
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                        _createTextVNode("mdi-check", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[46] || (_cache[46] = _createTextVNode("Creează ", -1))
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogLinie,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dialogLinie) = $event)),
      "max-width": "560",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          rounded: "xl",
          class: "dlg-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_v_icon, {
                  color: "#fff",
                  size: "20"
                }, {
                  default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                    _createTextVNode("mdi-file-document-plus-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[48] || (_cache[48] = _createElementVNode("div", null, [
                _createElementVNode("div", { class: "dlg-title" }, "Document nou"),
                _createElementVNode("div", { class: "dlg-desc" }, "Adaugă un document de decontat.")
              ], -1)),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                color: "#fff",
                size: "small",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogLinie = false))
              })
            ]),
            _createVNode(_component_v_card_text, { class: "pa-5" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, {
                  modelValue: _ctx.formLinieValid,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formLinieValid) = $event)),
                  ref: "formLinie"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.formLinie.TipID,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formLinie.TipID) = $event)),
                      items: _ctx.tipuri,
                      "item-title": "Nume",
                      "item-value": "Id",
                      label: "Tip document",
                      variant: "outlined",
                      density: "comfortable",
                      class: "mb-4",
                      rules: [_ctx.required],
                      loading: _ctx.loadingLookups,
                      "hide-details": "auto"
                    }, null, 8, ["modelValue", "items", "rules", "loading"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.formLinie.Numar,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formLinie.Numar) = $event)),
                      label: "Număr document",
                      variant: "outlined",
                      density: "comfortable",
                      class: "mb-4",
                      "hide-details": "auto"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_checkbox, {
                      modelValue: _ctx.formLinie.NuExistaPartener,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formLinie.NuExistaPartener) = $event)),
                      label: "Nu există partener",
                      density: "comfortable",
                      "hide-details": "",
                      class: "mb-2"
                    }, null, 8, ["modelValue"]),
                    (!_ctx.formLinie.NuExistaPartener)
                      ? (_openBlock(), _createBlock(_component_v_select, {
                          key: 0,
                          modelValue: _ctx.formLinie.PartenerID,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formLinie.PartenerID) = $event)),
                          items: _ctx.parteneri,
                          "item-title": "Nume",
                          "item-value": "Id",
                          label: "Partener",
                          variant: "outlined",
                          density: "comfortable",
                          class: "mb-4",
                          loading: _ctx.loadingLookups,
                          "hide-details": "auto",
                          clearable: ""
                        }, null, 8, ["modelValue", "items", "loading"]))
                      : (_openBlock(), _createBlock(_component_v_text_field, {
                          key: 1,
                          modelValue: _ctx.formLinie.PartenerNume,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formLinie.PartenerNume) = $event)),
                          label: "Nume partener",
                          variant: "outlined",
                          density: "comfortable",
                          class: "mb-4",
                          "hide-details": "auto"
                        }, null, 8, ["modelValue"])),
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.formLinie.Total,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formLinie.Total) = $event)),
                        modelModifiers: { number: true },
                        label: "Total",
                        type: "number",
                        variant: "outlined",
                        density: "comfortable",
                        rules: [_ctx.required],
                        "hide-details": "auto",
                        class: "flex-1-1"
                      }, null, 8, ["modelValue", "rules"]),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.formLinie.ValutaID,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formLinie.ValutaID) = $event)),
                        items: _ctx.valute,
                        "item-title": "Simbol",
                        "item-value": "Id",
                        label: "Valută",
                        variant: "outlined",
                        density: "comfortable",
                        loading: _ctx.loadingLookups,
                        "hide-details": "auto",
                        style: {"max-width":"130px"}
                      }, null, 8, ["modelValue", "items", "loading"])
                    ]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.formLinie.Explicatie,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formLinie.Explicatie) = $event)),
                      label: "Explicație",
                      variant: "outlined",
                      density: "comfortable",
                      rows: "2",
                      class: "mb-4",
                      "hide-details": "auto"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_file_input, {
                      modelValue: _ctx.formLinie.files,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formLinie.files) = $event)),
                      label: "Documente atașate",
                      variant: "outlined",
                      density: "comfortable",
                      multiple: "",
                      accept: ".pdf,.jpg,.jpeg,.png",
                      "prepend-icon": "",
                      "prepend-inner-icon": "mdi-paperclip",
                      "hide-details": "auto"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.errLinie)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      type: "error",
                      variant: "tonal",
                      density: "compact",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.errLinie), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "dlg-foot" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialogLinie = false))
                }, {
                  default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  class: "btn-nou px-6",
                  loading: _ctx.loadingLinie,
                  disabled: !_ctx.formLinieValid,
                  onClick: _ctx.adaugaLinie
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                        _createTextVNode("mdi-plus", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[51] || (_cache[51] = _createTextVNode("Adaugă linie ", -1))
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}